const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinadeckLogoWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 121 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13 -161)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.4 2.2)",
    fill: "#0225a1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.8 0 0 1.8 -13 -77)",
    strokeWidth: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    id: "finadeck-logo",
    transform: "matrix(.55 0 0 .55 14 130)",
    d: "m100 7.8a3.6 3.6 0 00-3.2 1.8l-22 36-13-22a3.6 3.6 0 00-3-1.8 3.6 3.6 0 00-3.1 1.6l-7.8 12-6.7-11a3.6 3.6 0 00-6.1-.22l-28 41a3.6 3.6 0 105.9 4.1l25-36 5.6 9.6-40 60a3.6 3.6 0 106 4l38-57 14 23a3.6 3.6 0 006.2.039l7.3-12 7.1 12a3.6 3.6 0 006.2-.025l15-27a3.6 3.6 0 10-6.3-3.6l-12 21-5.9-10 24-40a3.6 3.6 0 00-3-5.5zm-41 25 12 20-6.2 10-12-21z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    fill: "#0225a1",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinadeckLogoWeb);
export default __webpack_public_path__ + "static/media/finadeck-logo-web.7748df2f920cb074f369fa8be46ad61e.svg";
export { ForwardRef as ReactComponent };